var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container navigate-top",class:{ hasLeft: false, collapsed: _vm.isCollapse }},[_c('div',{staticClass:"right-wrapper"},[_c('common-iframe',{attrs:{"srcInfo":_vm.frameSrc,"frameborder":"0"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }